import UserListFilter from "../../components/composite/UserListFilter";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import Switch from "@mui/material/Switch";
import React from "react";
import { InputLabel } from "@mui/material";
import MuiButton from "../../components/basicComponent/MuiButton";
import { MuiInput } from "../../components/basicComponent/MuiInput";

const label = { inputProps: { "aria-label": "Switch demo" } };

const FlightRating = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const timeOptions = [
    { label: "Seconds", value: "seconds" },
    { label: "Minutes", value: "minutes" },
    { label: "Hours", value: "hours" },
    { label: "Days", value: "days" },
  ];

  const FilterPopUp = () => {
    return (
      <>
        <div className="card-body grid gap-10 d-flex">
          <div className="flex items-center flex-wrap lg:flex-nowrap">
            <MuiInput label={"Rate"} />
          </div>
          <div className="flex items-center flex-wrap lg:flex-nowrap">
            <MuiDropDown
              placeholder={""}
              options={timeOptions}
              onChange={function (value: string, id: string): void {
                throw new Error("Function not implemented.");
              }}
              value={""}
            />
          </div>
        </div>

        <div className="user-button w-full">
          <MuiButton className="get-btn" label="Get" type="submit" />
          <MuiButton className="clear-btn" label="Clear" type="submit" />
        </div>
      </>
    );
  };
  return (
    <>
      <div className="grow">
        <SideMenu />
        <div className="wrapper flex grow flex-col">
          <Header />
          <main className="grow content" id="content" role="content">
            <div className="container-fixed">
              <div className="card-header text-center">
                <h3 className="card-title">Throttle Management</h3>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-custom">
                    <div className="card-header mt-4 ms-4">
                      <div className="d-flex">
                        <div
                          className="user-manage-model w-full"
                          style={{ width: "270px" }}
                        >
                          <MuiDropDown
                            label="Scope"
                            placeholder={"Scope"}
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>

                        <div className="ms-3 mt-1 ">
                          <button className="btn btn-success btn-sm py-1">
                            <i className="ki-filled ki-setting-4"></i>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover">
                            <thead className=" text-nowrap">
                              <tr>
                                <th>
                                  <span className="sort">Scope</span>
                                </th>
                                <th>Rate</th>
                                <th>Enabled</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>login</td>
                                <td>5/minute</td>
                                <td>
                                  <Switch {...label} />
                                </td>
                                <td onClick={handleOpen}>
                                  <span className="badge badge-sm badge-warning badge-outline">
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td>otp</td>
                                <td> 2/minute</td>
                                <td>
                                  <Switch {...label} defaultChecked />
                                </td>
                                <td>
                                  <span className="badge badge-sm badge-warning badge-outline">
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td>register</td>
                                <td>10/minute</td>
                                <td>
                                  <Switch {...label} defaultChecked />
                                </td>
                                <td>
                                  <span className="badge badge-sm badge-warning badge-outline">
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*-----------------pop code----------------------------  */}
            <UserListFilter
              header={"Filter"}
              children={<FilterPopUp />}
              isVisible={open}
              handleClose={() => handleClose()}
            />
          </main>
        </div>
      </div>
    </>
  );
};

export default FlightRating;
